// @flow

import React from 'react';
import Star from '../star';
import StyledStars, { StarsWrapper } from './stars.styled';
import type { ReviewView } from '../../../../types';

type Props = {
  id?: number,
  rating: number,
  view: ReviewView,
};

const createStarValues = rating => {
  const fullStars = Math.floor(rating / 2);

  if (rating === 10) {
    return Array(fullStars).fill(1);
  }

  return [
    ...Array(fullStars).fill(1),
    ...[(rating % 2) / 2],
    ...Array(4 - fullStars).fill(0),
  ];
};

const Stars = ({
  id,
  rating,
  view,
}: Props) => {
  const starValues = createStarValues(rating);

  return (
    <StarsWrapper>
      <StyledStars view={view}>
        {starValues.map((value, index) => (
          <Star
            key={index} //  eslint-disable-line react/no-array-index-key
            id={`${id ? id.toString() : 1}_${index}`}
            stop={value}
          />
        ))}
      </StyledStars>
    </StarsWrapper>
  );
};

Stars.defaultProps = {
  id: 1,
};

export default Stars;
